<div class="icon">
    <mat-icon svgIcon="add-remaining"></mat-icon>
</div>
<div *ngIf="pack.hasUnavailableItems">
    <b class="heading t6">Some items unavailable</b>
    <div class="subheading">
        <div class="center">Below items in <b>{{pack.name}}</b> are unavailable.</div>
        <div class="center">Do you still want to add the remaining items?</div>
    </div>
    <div class="product-container">
        <div *ngFor="let product of pack.materials">
            <div class="unavailable-items" *ngIf="product.unavailable">
                <div class="product-details-container">
                    <b class="product-name t2">
                        <span *ngIf="product.packQuantity - product.availableQuantity > 0">
                            {{product.packQuantity - product.availableQuantity}} x </span>
                        {{product.unitOfMeasure | uppercase}}
                        {{product.name}}</b>
                    <div class="product-barcode t1">SKU {{product.barcode}}</div>
                </div>
                <div class="product-availability-container" *ngIf="product.unavailable">
                    <b class="product-quantity t1">UNAVAILABLE</b>
                </div>
            </div>
        </div>
    </div>
</div>
<mat-dialog-actions>
    <div class="actions">
        <button class="btn btn-link btn-block" mat-button [mat-dialog-close]="false" cdkFocusInitial>
            <div class="t3">CANCEL</div>
        </button>
        <button class="btn btn-primary btn-block" *ngIf="canAddPackWithUnavailableMaterials" mat-button
            [mat-dialog-close]="pack">
            <div class="t3">ADD REMAINING</div>
        </button>
    </div>
</mat-dialog-actions>